var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShippingAdvance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.57143H29.5714V9.2226L25.5221 5.28571H21V9.57143ZM21 11V15.9997C21.6516 15.1324 22.6889 14.5714 23.8571 14.5714C25.3217 14.5714 26.5803 15.4529 27.1314 16.7143H29.5714V11H21ZM19.5714 16.7143V3.85714V2.42857H2.42857V16.7143H3.44003C3.99114 15.4529 5.24977 14.5714 6.71429 14.5714C8.1788 14.5714 9.43743 15.4529 9.98854 16.7143H19.5714ZM21 3.85714H26.102L31 8.61905V16.7143C31 17.5033 30.3604 18.1429 29.5714 18.1429H27.4286C27.4286 20.1153 25.8296 21.7143 23.8571 21.7143C21.8847 21.7143 20.2857 20.1153 20.2857 18.1429H10.2857C10.2857 20.1153 8.68673 21.7143 6.71429 21.7143C4.74184 21.7143 3.14286 20.1153 3.14286 18.1429H2.42857C1.63959 18.1429 1 17.5033 1 16.7143V2.42857C1 1.63959 1.63959 1 2.42857 1H19.5714C20.3604 1 21 1.63959 21 2.42857V3.85714ZM6.71429 20.2857C7.89775 20.2857 8.85714 19.3263 8.85714 18.1429C8.85714 16.9594 7.89775 16 6.71429 16C5.53082 16 4.57143 16.9594 4.57143 18.1429C4.57143 19.3263 5.53082 20.2857 6.71429 20.2857ZM23.8571 20.2857C25.0406 20.2857 26 19.3263 26 18.1429C26 16.9594 25.0406 16 23.8571 16C22.6737 16 21.7143 16.9594 21.7143 18.1429C21.7143 19.3263 22.6737 20.2857 23.8571 20.2857Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingAdvance);
export default __webpack_public_path__ + "static/media/shipping_advance.4e4b6e16e936196161e9acafdd3766b5.svg";
export { ForwardRef as ReactComponent };